import './helpers.js';
import { e as registerComponent, u as use } from './plugins-4daf8ef8.js';
import './Icon-4445210d.js';
import 'vue';
import './FormElementMixin-43e56c3f.js';
import { s as script } from './Select-3447d119.js';
export { s as OSelect } from './Select-3447d119.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, script);
  }

};
use(Plugin);

export default Plugin;
